var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOpenPositionsBgMobile = function SvgOpenPositionsBgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 558,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M557.948 154v513.042h-889.142s3.82-545.52 0-598.174c-3.82-52.653-55.797-90.79 1.92-82.326 57.718 8.464 144.04 1.48 196.316 23.192 52.276 21.712 34.34-9.94 137.73 12.328 103.39 22.268 109.63-15.683 168.241 20.094 58.612 35.777 62.32 8.078 152.399 32.873C415.491 99.824 529.588 61.788 557.948 154Z",
    fill: "#F5D193"
  })));
};

export default SvgOpenPositionsBgMobile;